export default __webpack_public_path__ + "static/media/during-preparation.3848279c.svg";